import ApiService from "@/services/api.service"

export const EloquentService = {
  autocomplete(model, q, pagination = null, loader = true, superadmin = false, clinic_id = null, branch_id = null, additionalParams = null, page = 1) {
    return ApiService.get(`${superadmin ? 'superadmin/' : ''}autocomplete`, { q, model, pagination, clinic_id, branch_id, additionalParams, page },{ loader })
  },
  prepare(model, params = {}, superadmin = false) {
    return ApiService.get(`${superadmin ? 'superadmin/' : ''}eloquent/prepare`, { model: model, params: params })
  },
  show(model, id, superadmin = false, loader = true, params = {}) {
    return ApiService.get(`${superadmin ? 'superadmin/' : ''}eloquent/show`, { model: model, id: id, ...params }, { loader })
  },
  create(model, params, superadmin = false) {
    return ApiService.post(`${superadmin ? 'superadmin/' : ''}eloquent/${model}/create`, params, {'Content-Type': 'multipart/form-data'})
  },
  update(model, id, params, superadmin = false, loader = true) {
    return ApiService.post(`${superadmin ? 'superadmin/' : ''}eloquent/${model}/update/${id}`, params, {'Content-Type': 'multipart/form-data'}, { loader })
  },
  patch(model, id, params, superadmin = false, loader = true) {
    return ApiService.patch(`${superadmin ? 'superadmin/' : ''}eloquent/${model}/patch/${id}`, params, {}, { loader })
  },
  delete(model, id, superadmin = false, additionalParams = null) {
    let queryString = ''
    if(additionalParams) {
      const str = new URLSearchParams(additionalParams).toString()
      if(str) queryString = `?${str}`
    }
    return ApiService.delete(`${superadmin ? 'superadmin/' : ''}eloquent/${model}/delete/${id}${queryString}`)
  },
  preDelete(model, id, superadmin = false) {
    return ApiService.post(`${superadmin ? 'superadmin/' : ''}eloquent/${model}/preDelete/${id}`)
  },
  deleteBulk(model, ids, superadmin = false) {
    return ApiService.post(`${superadmin ? 'superadmin/' : ''}eloquent/${model}/deletebulk`, { ids })
  },
  restore(model, id, superadmin = false) {
    return ApiService.post(`${superadmin ? 'superadmin/' : ''}eloquent/${model}/restore/${id}`)
  },
  dataTable(model, page = 1, params = {}, loader = true, superadmin = false) {
    return ApiService.get(`${superadmin ? 'superadmin/' : ''}datatable`, { model: model, page: page, ...params }, {loader: loader})
  },
  excel(model, conditions = {}, filters = {}, superadmin = false) {
    let params = { excel: true }
    params.condition = conditions
    params.filters = filters
    return ApiService.get(`${superadmin ? 'superadmin/' : ''}datatable`, { model: model, ...params })
  },
  loadSortingData(model) {
    return ApiService.get(`eloquent/${model}/sorting/get`)
  },
  saveSortingData(model, params) {
    return ApiService.post(`eloquent/${model}/sorting/save`, params)
  },
}
